// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../../node_modules/primereact/resources/themes/saga-blue/theme.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../../node_modules/primereact/resources/primereact.min.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!../../node_modules/primeicons/primeicons.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-family: serif;
}

.video-wrapper {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.controls {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  width: 100%;
  max-width: 500px;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.25);
  box-shadow: 0 8px 32px 0 rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  transform: translateY(0);
  transition: all 0.3s ease-in-out;
  z-index: 9;
  opacity: 0.3;
}

.video-wrapper:hover .controls {
  transform: translateY(50%);
  opacity: 1;
}

.video-wrapper:hover .actions {
  opacity: 1;
  transition: 0.5s;
}

.actions {
  opacity: 0.3;
  position: absolute;
  z-index: 10;
  top: 35%;
  border-radius: 50%;
  background-color: rgba(45, 37, 37, 0.5);
  padding: 0.5rem;
  transition: 0.5s;
}
.actions button {
  background: none;
  border: none;
  outline: none;
  cursor: pointer;
}
.actions button i {
  color: black;
  font-size: 16px;
}

input[type=range] {
  -webkit-appearance: none !important;
  background: black;
  border-radius: 20px;
  height: 4px;
  width: 350px;
}

.itemBox {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 1rem;
  overflow-x: hidden;
  width: 90%;
  padding: 0.5rem;
  z-index: 4;
  justify-content: flex-end;
  height: 70%;
  overflow-y: scroll !important;
}

.insideItemBox {
  margin-bottom: 4px;
  font-family: "tahoma";
  letter-spacing: 1px;
}

.logo {
  display: none;
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.25);
  color: white;
  padding: 0 0.25rem;
  z-index: 10;
}
.logo img {
  width: 1.5rem;
  height: 1.5rem;
}

.itemBox::-webkit-scrollbar {
  background-color: #8f8f8f;
  border-radius: 0.5rem;
  width: 0.25rem;
  height: 0.5rem;
}

.item {
  text-align: left;
  border: 1px solid rgb(204, 204, 204);
  margin: 0.25rem;
  padding: 0.5rem;
  border-radius: 2rem;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
  cursor: pointer;
  transition: 1s;
  width: 100%;
}
.item:hover {
  transition: 1s;
  transform: scale(0.95);
}

.num {
  color: white;
  background-color: orange;
  font-size: 0.8rem;
  padding: 0.25rem;
  border-radius: 100%;
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  text-align: center;
  margin-right: 0.5rem;
}

.register {
  position: absolute;
  bottom: 2rem;
  cursor: pointer;
  z-index: 100;
  width: 100%;
  text-align: center;
}

video {
  z-index: 3;
}

.animation-action {
  animation-name: borderHover;
  animation-duration: 0.5s;
}

@keyframes borderHover {
  0% {
    border: 1px solid gold;
    opacity: 0.5;
  }
  50% {
    border: 1px solid rgb(204, 204, 204);
    opacity: 1;
  }
  100% {
    border: 1px solid gold;
    opacity: 0.5;
  }
}
.parent-loader {
  width: 100%;
  height: 100%;
  background-color: rgba(185, 182, 182, 0.6);
}
.parent-loader .loader {
  color: white;
  font-size: 10px;
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  position: absolute;
  text-indent: -9999em;
  animation: mulShdSpin 1.3s infinite linear;
  transform: translateZ(0);
  display: inline-block;
  z-index: 1000;
  top: 50%;
  right: 50%;
}

@keyframes mulShdSpin {
  0%, 100% {
    box-shadow: 0 -3em 0 0.2em, 2em -2em 0 0em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 0;
  }
  12.5% {
    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em, 3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  25% {
    box-shadow: 0 -3em 0 -0.5em, 2em -2em 0 0, 3em 0 0 0.2em, 2em 2em 0 0, 0 3em 0 -1em, -2em 2em 0 -1em, -3em 0 0 -1em, -2em -2em 0 -1em;
  }
  37.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em, -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  50% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em, -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;
  }
  62.5% {
    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0, -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;
  }
  75% {
    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em, 3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;
  }
  87.5% {
    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em, 3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em, -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;
  }
}
.Tahoma {
  font-family: Tahoma !important;
}

/* CSS */
.button-36 {
  background-image: linear-gradient(92.88deg, #455EB5 9.16%, #5643CC 43.89%, #673FD7 64.72%);
  border-radius: 8px;
  border-style: none;
  box-sizing: border-box;
  color: #FFFFFF;
  cursor: pointer;
  flex-shrink: 0;
  font-family: "Inter UI", "SF Pro Display", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-size: 16px;
  font-weight: 500;
  height: 4rem;
  padding: 0 1.6rem;
  text-align: center;
  text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;
  transition: all 0.5s;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
}

.button-36:hover {
  box-shadow: rgba(80, 63, 205, 0.5) 0 1px 30px;
  transition-duration: 0.1s;
}

@media (min-width: 768px) {
  .button-36 {
    padding: 0 2.6rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/player.scss"],"names":[],"mappings":"AAOA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAHF;;AAMA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,qCAAA;EACA,iDAAA;EACA,0BAAA;EACA,kCAAA;EACA,mBAAA;EACA,2CAAA;EACA,wBAAA;EACA,gCAAA;EACA,UAAA;EACA,YAAA;AAHF;;AAOA;EACE,0BAAA;EACA,UAAA;AAJF;;AAOA;EACE,UAAA;EACA,gBAAA;AAJF;;AAOA;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,kBAAA;EACA,uCAAA;EACA,eAAA;EACA,gBAAA;AAJF;AAME;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AAJJ;AAMI;EACE,YAAA;EACA,eAAA;AAJN;;AASA;EACE,mCAAA;EACA,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AANF;;AASA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;EACA,WAAA;EACE,6BAAA;AANJ;;AAUA;EACE,kBAAA;EACA,qBAAA;EACA,mBAAA;AAPF;;AAUA;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AAPF;AAQE;EACE,aAAA;EACA,cAAA;AANJ;;AAUA;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,cAAA;AAPF;;AAUA;EACE,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;EACA,oCAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AAPF;AASE;EACE,cAAA;EACA,sBAAA;AAPJ;;AAWA;EACE,YAAA;EACA,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;AARF;;AAWA;EACE,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AARF;;AAWA;EACE,UAAA;AARF;;AAWA;EACE,2BAAA;EACA,wBAAA;AARF;;AAWA;EACE;IACE,sBAAA;IACA,YAAA;EARF;EAUA;IACE,oCAAA;IACA,UAAA;EARF;EAUA;IACE,sBAAA;IACA,YAAA;EARF;AACF;AAcA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;AAZF;AAcE;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,oBAAA;EACA,0CAAA;EACA,wBAAA;EACA,qBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;AAZJ;;AAgBA;EACE;IAEE,qIAAA;EAdF;EAoBA;IACE,mIAAA;EAlBF;EAuBA;IACE,qIAAA;EArBF;EA2BA;IACE,yIAAA;EAzBF;EA6BA;IACE,uIAAA;EA3BF;EA+BA;IACE,mIAAA;EA7BF;EAiCA;IACE,yIAAA;EA/BF;EAmCA;IACE,oIAAA;EAjCF;AACF;AAsCA;EACE,8BAAA;AApCF;;AAwCA,QAAA;AACA;EACE,0FAAA;EACA,kBAAA;EACA,kBAAA;EAAoB,sBAAA;EAAwB,cAAA;EAAgB,eAAA;EAAiB,cAAA;EAC7E,sKAAA;EACY,eAAA;EAAiB,gBAAA;EAAkB,YAAA;EAAc,iBAAA;EAAmB,kBAAA;EAAoB,0CAAA;EACpG,oBAAA;EAAqB,iBAAA;EAAmB,yBAAA;EAA2B,0BAAA;AAzBrE;;AA0BA;EAAmB,6CAAA;EAA+C,yBAAA;AArBlE;;AAsBA;EAA4B;IAAa,iBAAA;EAjBvC;AACF","sourcesContent":["//video ask css\n\n@import 'primereact/resources/themes/saga-blue/theme.css';\n@import 'primereact/resources/primereact.min.css';\n@import 'primeicons/primeicons.css';\n\n\n.container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  font-family: serif;\n}\n\n.video-wrapper {\n  width: 100%;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  max-width: 500px;\n  flex-wrap: wrap;\n  background: rgba(255, 255, 255, 0.25);\n  box-shadow: 0 8px 32px 0 rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  transform: translateY(0);\n  transition: all 0.3s ease-in-out;\n  z-index: 9;\n  opacity: .3;\n}\n\n\n.video-wrapper:hover .controls {\n  transform: translateY(50%);\n  opacity: 1;\n}\n\n.video-wrapper:hover .actions {\n  opacity: 1;\n  transition: .5s;\n}\n\n.actions {\n  opacity: .3;\n  position: absolute;\n  z-index: 10;\n  top: 35%;\n  border-radius: 50%;\n  background-color: rgb(45 37 37 / 50%);\n  padding: 0.5rem;\n  transition: .5s;\n\n  & button {\n    background: none;\n    border: none;\n    outline: none;\n    cursor: pointer;\n\n    & i {\n      color: black;\n      font-size: 16px;\n    }\n  }\n}\n\ninput[type=\"range\"] {\n  -webkit-appearance: none !important;\n  background: black;\n  border-radius: 20px;\n  height: 4px;\n  width: 350px;\n}\n\n.itemBox {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  bottom: 1rem;\n  overflow-x: hidden;\n  width: 90%;\n  padding: 0.5rem;\n  z-index: 4;\n  justify-content: flex-end;\n  height: 70%;\n    overflow-y: scroll !important;\n\n}\n\n.insideItemBox {\n  margin-bottom: 4px;\n  font-family: \"tahoma\";\n  letter-spacing: 1px;\n}\n\n.logo {\n  display:none;\n  position: absolute;\n  width: 100%;\n  text-align: center;\n  bottom: 0;\n  background-color: rgba(255, 255, 255, 0.25);\n  color: white;\n  padding: 0 .25rem;\n  z-index: 10;\n  & img {\n    width: 1.5rem;\n    height: 1.5rem;\n  }\n}\n\n.itemBox::-webkit-scrollbar {\n  background-color: #8f8f8f;\n  border-radius: .5rem;\n  width: .25rem;\n  height: .5rem;\n}\n\n.item {\n  text-align: left;\n  border: 1px solid rgb(204, 204, 204);\n  margin: .25rem;\n  padding: .5rem;\n  border-radius: 2rem;\n  background-color: rgba(0, 0, 0, .4);\n  color: white;\n  cursor: pointer;\n  transition: 1s;\n  width: 100%;\n\n  &:hover {\n    transition: 1s;\n    transform: scale(.95);\n  }\n}\n\n.num {\n  color: white;\n  background-color: orange;\n  font-size: .8rem;\n  padding: .25rem;\n  border-radius: 100%;\n  width: 1.5rem;\n  height: 1.5rem;\n  display: inline-block;\n  text-align: center;\n  margin-right: .5rem;\n}\n\n.register {\n  position: absolute;\n  bottom: 2rem;\n  cursor: pointer;\n  z-index: 100;\n  width: 100%;\n  text-align: center;\n}\n\nvideo {\n  z-index: 3;\n}\n\n.animation-action {\n  animation-name: borderHover;\n  animation-duration: .5s;\n}\n\n@keyframes borderHover {\n  0% {\n    border: 1px solid gold;\n    opacity: .5;\n  }\n  50% {\n    border: 1px solid rgb(204, 204, 204);\n    opacity: 1;\n  }\n  100% {\n    border: 1px solid gold;\n    opacity: .5;\n  }\n}\n\n\n// loader css\n\n.parent-loader {\n  width: 100%;\n  height: 100%;\n  background-color: rgba(185, 182, 182, 0.6);\n\n  .loader {\n    color: white;\n    font-size: 10px;\n    width: 1rem;\n    height: 1rem;\n    border-radius: 50%;\n    position: absolute;\n    text-indent: -9999em;\n    animation: mulShdSpin 1.3s infinite linear;\n    transform: translateZ(0);\n    display: inline-block;\n    z-index: 1000;\n    top: 50%;\n    right: 50%;\n  }\n}\n\n@keyframes mulShdSpin {\n  0%,\n  100% {\n    box-shadow: 0 -3em 0 0.2em,\n    2em -2em 0 0em, 3em 0 0 -1em,\n    2em 2em 0 -1em, 0 3em 0 -1em,\n    -2em 2em 0 -1em, -3em 0 0 -1em,\n    -2em -2em 0 0;\n  }\n  12.5% {\n    box-shadow: 0 -3em 0 0, 2em -2em 0 0.2em,\n    3em 0 0 0, 2em 2em 0 -1em, 0 3em 0 -1em,\n    -2em 2em 0 -1em, -3em 0 0 -1em,\n    -2em -2em 0 -1em;\n  }\n  25% {\n    box-shadow: 0 -3em 0 -0.5em,\n    2em -2em 0 0, 3em 0 0 0.2em,\n    2em 2em 0 0, 0 3em 0 -1em,\n    -2em 2em 0 -1em, -3em 0 0 -1em,\n    -2em -2em 0 -1em;\n  }\n  37.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\n    3em 0em 0 0, 2em 2em 0 0.2em, 0 3em 0 0em,\n    -2em 2em 0 -1em, -3em 0em 0 -1em, -2em -2em 0 -1em;\n  }\n  50% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\n    3em 0 0 -1em, 2em 2em 0 0em, 0 3em 0 0.2em,\n    -2em 2em 0 0, -3em 0em 0 -1em, -2em -2em 0 -1em;\n  }\n  62.5% {\n    box-shadow: 0 -3em 0 -1em, 2em -2em 0 -1em,\n    3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 0,\n    -2em 2em 0 0.2em, -3em 0 0 0, -2em -2em 0 -1em;\n  }\n  75% {\n    box-shadow: 0em -3em 0 -1em, 2em -2em 0 -1em,\n    3em 0em 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em,\n    -2em 2em 0 0, -3em 0em 0 0.2em, -2em -2em 0 0;\n  }\n  87.5% {\n    box-shadow: 0em -3em 0 0, 2em -2em 0 -1em,\n    3em 0 0 -1em, 2em 2em 0 -1em, 0 3em 0 -1em,\n    -2em 2em 0 0, -3em 0em 0 0, -2em -2em 0 0.2em;\n  }\n}\n\n.Tahoma {\n  font-family: Tahoma !important;\n}\n\n\n/* CSS */\n.button-36 {\n  background-image: linear-gradient(92.88deg, #455EB5 9.16%, #5643CC 43.89%, #673FD7 64.72%);\n  border-radius: 8px;\n  border-style: none; box-sizing: border-box; color: #FFFFFF; cursor: pointer; flex-shrink: 0;\n  font-family: \"Inter UI\",\"SF Pro Display\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Open Sans\",\"Helvetica Neue\",\n  sans-serif; font-size: 16px; font-weight: 500; height: 4rem; padding: 0 1.6rem; text-align: center; text-shadow: rgba(0, 0, 0, 0.25) 0 3px 8px;\n  transition: all .5s; user-select: none; -webkit-user-select: none; touch-action: manipulation; }\n.button-36:hover { box-shadow: rgba(80, 63, 205, 0.5) 0 1px 30px; transition-duration: .1s; }\n@media (min-width: 768px) { .button-36 { padding: 0 2.6rem; } }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
